module.exports = __webpack_public_path__ + "static/media/Pinata Boy.de99ff3e.jpg";